import { Pipe, PipeTransform } from '@angular/core';

let wholeFmt: Intl.NumberFormat;
let decFmt: Intl.NumberFormat;

@Pipe({
	name: 'dollarsDisplay',
})
export class DollarsDisplayPipe implements PipeTransform {
	transform(valueInCents: number | null | undefined): string | null {
		if (valueInCents == null) return null;

		const dollars = valueInCents / 100;
		const isWholeDollar = valueInCents % 100 === 0;
		if (!wholeFmt) {
			wholeFmt = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 0,
			});
			decFmt = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		}
		return (isWholeDollar ? wholeFmt : decFmt).format(dollars);
	}
}
